var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"choose_video2"},[_c('ul',{staticClass:"choose_video_list"},_vm._l((_vm.productMediaData.videoList),function(video){return _c('li',[_c('div',{staticClass:"result_banner2_img",on:{"click":_vm.openVideoPlayer}})])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }